export const ACTION = '/StoreLocator/GetDefaultStoreLocator';
